export enum EMappedTypeOffer {
  OFFER = 'offer',
  MULTI = 'multi',
}
